import { render, staticRenderFns } from "./ControleAdesoesView.vue?vue&type=template&id=5e22e54d&scoped=true"
import script from "./ControleAdesoesView.vue?vue&type=script&lang=js"
export * from "./ControleAdesoesView.vue?vue&type=script&lang=js"
import style0 from "./ControleAdesoesView.vue?vue&type=style&index=0&id=5e22e54d&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e22e54d",
  null
  
)

export default component.exports